import "./styles/index.css";

//components
import { Game } from "./components/Game";

function App() {
  return (
    <div className="App">
      <Game />
    </div>
  );
}

export default App;
